import React from "react";
import { ReducerAction } from "../../hooks/ReducerOnChange";
import { CampoData, CampoNumero, Tipo, ValidationResult } from "..";
import { Distraints, DpsLiabilityTypes, LiabilityTypes, Insurers, Messages, NoInsurers } from "./Constants";
import { CDataLiabilityItem } from "../../form/DigitalProductAnalyser/PrimaryAnalyser";
import * as Glob from '../../Globale';

interface IOtherLiabilitiesFormProps {
    Data: CDataLiabilityItem[];
    OnChange: React.Dispatch<ReducerAction<CDataLiabilityItem[]>>;
    IsDpsPage?: boolean;
}

export const OtherLiabilitiesForm: React.FC<IOtherLiabilitiesFormProps> = ({ Data, OnChange, IsDpsPage }) => {
    const getValidationMessage = (item: CDataLiabilityItem): string => {
        if (item.LiabilityType == "Alimenti") {
            return (!item.Amount && !item.ResidualDebt && Messages.IndicateLoanAmount) || "";
        }

        if (item.LiabilityType == "AltriPrestiti") {
            return (
                (!item.Amount && !item.ResidualDebt && !item.ExpiryDate && Messages.IndicateLoanAmountDebtAndExpiryDate) ||
                (!item.Amount && !item.ResidualDebt && Messages.IndicateLoanAmountAndDebt) ||
                (item.Amount && item.ResidualDebt && !item.ExpiryDate && Messages.IdicateExpiryDate) ||
                (item.Amount && !item.ExpiryDate && Messages.IndicateDebtAndExpiryDate) ||
                ""
            );
        }

        if (Distraints.includes(item.LiabilityType)) {
            return (!item.Amount && !item.ResidualDebt && !item.ExpiryDate && Messages.IndicateLoanAmount) || "";
        }

        return (
            (!item.Amount && !item.ResidualDebt && !item.ExpiryDate && Messages.IndicateLoanAmountDebtAndExpiryDate) ||
            (!item.Amount && !item.ResidualDebt && Messages.IndicateLoanAmountAndDebt) ||
            (!item.Amount && !item.ExpiryDate && Messages.IndicateLoanAmountAndExpiryDate) ||
            (!item.ResidualDebt && !item.ExpiryDate && Messages.IndicateDebtAndExpiryDate) ||
            (!item.ExpiryDate && Messages.IdicateExpiryDate) ||
            (!item.Amount && Messages.IndicateLoanAmount) ||
            (!item.ResidualDebt && Messages.IndicateDebt) ||
            ""
        );
    };

    const addLiabilityItem = () => {
        OnChange({
            Type: "Set",
            Value: [...Data, new CDataLiabilityItem()]
        });
    };

    const removeLiabilityItem = (index: number) => {
        Data.splice(index, 1);
        OnChange({
            Type: "Set",
            Value: [...Data]
        });
    };

    const validationMessages: string[] = Data.map((item: CDataLiabilityItem) => getValidationMessage(item));
    const isFormInValid: boolean = !!validationMessages.filter(item => item).length;

    return (
        <>
            <div className="col-lg-12 kt--align-right remove-square-button kt-padding-t-10">
                <button disabled={isFormInValid} type="button" className="btn btn-info square-button-with-icon" onClick={addLiabilityItem} title="Aggiungi">
                    <i className="fa fa-plus"></i>
                </button>
            </div>
            {Data.map((liabilityItem, index) => {
                const isDistraint = Distraints.includes(liabilityItem.LiabilityType);
                const isDateClearable = isDistraint || liabilityItem.LiabilityType == "Alimenti";

                return (
                    <div className={`form-group special-group kt-form login-form__group row ${index !== Data.length - 1 ? " dashedborder" : ""}`} key={index}>
                        <div className="col-lg-3">
                            <label>Tipologia di Coesistenza</label>
                            <Tipo
                                Dati={IsDpsPage ? DpsLiabilityTypes : LiabilityTypes}
                                Campo="LiabilityType"
                                ID_ChiaveString={liabilityItem.LiabilityType}
                                TradValori={false}
                                OnAggiorna={(e, v) => OnChange({ Type: "OnChangeFromValue", Name: `${index}.${e}`, Value: v })}
                                Richiesto
                            />
                        </div>
                        <div className="col-lg-5 row">
                            <div className="col-lg-4">
                                <label>Importo Rata</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <CampoNumero
                                        Id={`${index}.Amount`}
                                        Name={`${index}.Amount`}
                                        Valore={liabilityItem.Amount}
                                        OnChange={(e, v) => OnChange({ Type: "OnChangeFromHybrid", NameEvent: Object.assign({}, e), Value: v })}
                                        OnBlur={() => {
                                            if (liabilityItem.ResidualDebt && liabilityItem.Amount > liabilityItem.ResidualDebt) {
                                                OnChange({ Type: "OnChangeFromValue", Name: `${index}.Amount`, Value: 0 });
                                            }
                                        }}
                                        CSS="form-control kt-input"
                                        Icona={"fa " + Glob.ValutaSimbolo}
                                        Precisione={2}
                                        Minimo={0}
                                        Massimo={99999}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label>Residuo Debito</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <CampoNumero
                                        Id={`${index}.ResidualDebt`}
                                        Name={`${index}.ResidualDebt`}
                                        Valore={liabilityItem.ResidualDebt}
                                        OnChange={(e, v) => OnChange({ Type: "OnChangeFromHybrid", NameEvent: Object.assign({}, e), Value: v })}
                                        OnBlur={() => {
                                            if (liabilityItem.ResidualDebt < liabilityItem.Amount) {
                                                OnChange({ Type: "OnChangeFromValue", Name: `${index}.Amount`, Value: 0 });
                                            }
                                        }}
                                        CSS="form-control kt-input"
                                        Icona={"fa " + Glob.ValutaSimbolo}
                                        Precisione={2}
                                        Minimo={0}
                                        Massimo={99999}
                                    />
                                </div>
                            </div>

                            <div className="col-lg-4">
                                <label>Scadenza Prestito</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <div className="form-control">
                                        <CampoData
                                            ValoreInArrivo={false}
                                            Name={`${index}.ExpiryDate`}
                                            Id={`${index}.ExpiryDate`}
                                            Valore={liabilityItem.ExpiryDate}
                                            OnChange={(e, v) => OnChange({ Type: "OnChangeFromHybrid", NameEvent: e, Value: v })}
                                            DataMinima={new Date(Date.now())}
                                            OnBlur={(e: any) => {
                                                if (!e.target.value && !isDateClearable && liabilityItem.ExpiryDate) {
                                                    OnChange({ Type: "OnChangeFromValue", Name: `${index}.ExpiryDate`, Value: liabilityItem.ExpiryDate });
                                                }
                                            }}
                                            IsClearable={isDateClearable && !!liabilityItem.ExpiryDate}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <label>Assicuratore</label>
                            <div className="kt-input">
                                <Tipo
                                    Dati={liabilityItem.LiabilityType.includes("Delega") || liabilityItem.LiabilityType == "Cessione" ? Insurers : NoInsurers}
                                    Campo="Insurer"
                                    ID_ChiaveString={liabilityItem.Insurer}
                                    TradValori={false}
                                    OnAggiorna={(e, v) => OnChange({ Type: "OnChangeFromValue", Name: `${index}.${e}`, Value: v })}
                                    Richiesto
                                />
                            </div>
                        </div>
                        <div className="col-lg-2 row">
                            <ValidationResult Message={validationMessages[index]} Columns={10} />
                            <div className="col-lg-2 remove-square-button justify-content-start kt-padding-l-15">
                                <button type="button" className="btn btn-danger square-button-with-icon" onClick={() => removeLiabilityItem(index)} title="Elimina">
                                    <i className="fa fa-minus" />
                                </button>
                            </div>
                        </div>
                    </div>
                );
            })}
        </>
    );
};



// WEBPACK FOOTER //
// ./src/components/DigitalProductAnalyser/OtherLiabilitiesForm.tsx